import Container from './Container';

export const ProfessionalInfos: React.FC<{
  role: string;
  firstInfoTitle?: string;
  qualifications: string;
  secondInfoTitle?: string;
  professional_info: string;
  thirdInfoTitle?: string;
  thirdInfo?: string;
  fourthInfoTitle?: string;
  fourthInfo?: string;
}> = ({
  role,
  firstInfoTitle = 'Titolo',
  qualifications,
  secondInfoTitle = 'Informazioni professionali',
  professional_info,
  thirdInfoTitle,
  thirdInfo,
  fourthInfoTitle,
  fourthInfo,
}) => {
  const itemClassName = 'w-full md:w-auto gap-2 p-3 ';
  const titleClassName = 'self-stretch text-neutral-neutral-8 text-sm font-medium tracking-normal';
  const contentClassName = 'self-stretch text-neutral-neutral-alpha-12 text-base font-bold tracking-normal';
  return (
    <Container title={role}>
      <div className='flex w-full flex-wrap items-start gap-2 self-stretch'>
        {qualifications && (
          <div id='titlePro' className={itemClassName}>
            <div id='title1' className={titleClassName}>
              {firstInfoTitle}
            </div>
            <div id='value1' className={contentClassName}>
              {qualifications}
            </div>
          </div>
        )}
        {professional_info && (
          <div id='infoPro' className={itemClassName}>
            <div id='title2' className={titleClassName}>
              {secondInfoTitle}
            </div>
            <div id='value2' className={contentClassName}>
              {professional_info}
            </div>
          </div>
        )}
        {thirdInfoTitle && thirdInfo && (
          <div id='infoPro' className={itemClassName}>
            <div id='title2' className={titleClassName}>
              {thirdInfoTitle}
            </div>
            <div id='value2' className={contentClassName}>
              {thirdInfo}
            </div>
          </div>
        )}
        {fourthInfoTitle && fourthInfo && (
          <div id='infoPro' className={itemClassName}>
            <div id='title2' className={titleClassName}>
              {fourthInfoTitle}
            </div>
            <div id='value2' className={contentClassName}>
              {fourthInfo}
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};
export default ProfessionalInfos;
